// extracted by mini-css-extract-plugin
module.exports =  {"root":"uqdT4x09S_SxW2qvcWpt","icon":"d69OiBucQiug7XMt4a4F"};